import styled from 'styled-components';
import { device } from '../constants/device';

const ArticleContent = styled.main`
  padding: 40px 0;
  color: #2a2a2a;
  font-size: 20px;
  line-height: 1.5;
  letter-spacing: 0.5px;
  a {
    color: #e3383a;
  }
  h3 {
    margin: 30px 0 5px;
    font-size: 28px;
    & + p::first-letter {
      font-size: 36px;
    }
  }
  p {
    margin-bottom: 10px;
    line-height: 1.3;
  }
  img {
    height: auto;
    width: 100%;
    display: block;
    max-width: 100%;
    margin: 30px 0;
    &.inline {
      display: inline-block;
      max-width: 640px;
    }
    &.mid {
      max-width: 800px;
      margin: 30px auto;
    }
  }
  ul,
  ol {
    margin: 20px 0 30px;
    li {
      margin: 0 0 5px 35px;
      &:last-child {
        margin-bottom: 0;
      }
      span {
        display: block;
      }
    }
  }
  ul {
    & > li {
      list-style: disc;
    }
    &.circle {
      & > li {
        list-style: circle;
      }
    }
  }
  ol {
    & > li {
      list-style: decimal;
    }
  }
  ul ol,
  ol ul,
  ul ul,
  ol ol {
    margin-bottom: 0;
    margin-top: 0;
  }
  @media ${device.tablet} {
    padding: 20px 0;
    font-size: 16px;
    line-height: 1.2;
    p {
      text-align: justify;
    }
    h3 {
      margin: 20px 0 10px;
      font-size: 26px;
      & + p::first-letter {
        font-size: 26px;
      }
    }
  }
`;

export default ArticleContent;
